import React from 'react';
import {breadDirections} from '../data/breads';
import SectionIntro from './SectionIntro';

function BreadUniverse() {
  return (
    <section className="bread-universe" id="broeduniverset" aria-labelledby="bread-title">
      <SectionIntro label="BRØDUNIVERSET" title="SEKS BRØDRETNINGER. ÉT SAMLET BRAND.">
        <p id="bread-title">
          Det planlagte sortiment udvikles omkring seks forskellige brødtraditioner. De viste
          betegnelser er arbejdskategorier. Endelige produktnavne, varianter og specifikationer
          offentliggøres senere.
        </p>
      </SectionIntro>
      <div className="status-bar">SORTIMENT UNDER UDVIKLING</div>
      <div className="bread-grid">
        {breadDirections.map((bread) => (
          <article
            className="bread-panel"
            key={bread.number}
            style={{backgroundColor: bread.color, color: bread.textColor}}
          >
            <span className="bread-number">{bread.number}</span>
            <img
              className="bread-product-image"
              src={bread.image}
              alt=""
              loading="lazy"
              decoding="async"
            />
            <h3>{bread.name}</h3>
          </article>
        ))}
      </div>
    </section>
  );
}

export default BreadUniverse;